module.exports = "#vild-version-approve-success-msg {\n  color: green; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialog-vild-approve/dialog-vild-approve.component.scss
// module id = ./src/app/shared/dialog-vild-approve/dialog-vild-approve.component.scss
// module chunks = main